import { WEEKDAYS, callingDaysProblem } from "@components/scheduling/settings/settingsValidation";

const LABEL = (day) => day.charAt(0).toUpperCase() + day.slice(1);

/**
 * The days a campaign may place calls on. Always emits the chosen days back
 * in week order, regardless of which checkbox was clicked, so the draft
 * never depends on click order.
 */
export default function CallingDaysEditor({ days, onChange }) {
  const chosen = days || [];
  const problem = callingDaysProblem(chosen);

  const toggle = (day) => {
    const next = chosen.includes(day)
      ? chosen.filter((d) => d !== day)
      : [...chosen, day];
    onChange(WEEKDAYS.filter((d) => next.includes(d)));
  };

  return (
    <div>
      <div className="flex flex-wrap gap-3">
        {WEEKDAYS.map((day) => (
          <label key={day} className="flex items-center gap-1.5 text-sm text-gray-700">
            <input
              type="checkbox"
              checked={chosen.includes(day)}
              aria-label={LABEL(day)}
              onChange={() => toggle(day)}
            />
            {LABEL(day)}
          </label>
        ))}
      </div>
      {problem && <p className="mt-1 text-xs text-red-600">{problem}</p>}
    </div>
  );
}
